import { render, staticRenderFns } from "./LcAvatar.vue?vue&type=template&id=fb96acf0&"
import script from "./LcAvatar.vue?vue&type=script&lang=js&"
export * from "./LcAvatar.vue?vue&type=script&lang=js&"
import style0 from "./LcAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports